import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h2>Hi, I'm Eugene Siew.</h2>
    <p>While I have your attention for the next 7 seconds:</p>
    <ul>
      <li>I'm a Product Designer and A/V Engineer</li>
      <li>I've led projects at Facebook, <a href="https://www.notion.so/esiew/Projects-2bbb2397fdf442cdbd85ddaa60a134a5#60fef6c393fa4db9a9694f20ec50af4c" title="Go to Eugene's Wealthfront projects" target="blank">Wealthfront</a>, <a href="https://www.notion.so/esiew/Projects-2bbb2397fdf442cdbd85ddaa60a134a5#ace1fc1482414b0fb2e9360235a478bc" title="Go to Eugene's Apple projects" target="blank">Apple</a> and <a href="https://www.notion.so/esiew/Projects-2bbb2397fdf442cdbd85ddaa60a134a5#b27c95942bd2446d82e551d209643602" title="Go to Eugene's Bleacher Report projects" target="blank">Bleacher Report</a></li>
      <li>I'm passionate about design systems, improving <a href="https://developer.apple.com/videos/play/wwdc2017/809/" title="Go to WWDC 17 Design Studio Shorts talk on Communication Between Designers and Engineers" target="blank">communication between designers and engineers</a>, and designing/prototyping with code</li>
    </ul>
  </Layout>
)

export default IndexPage
